import Cookies from 'js-cookie'

const DEVICE_ID_COOKIE = `deviceId`
const DEVICE_ID_LIFETIME_DAYS = 365 * 10

/* eslint-disable no-bitwise */
const generateDeviceId = (): string =>
  `10000000-1000-4000-8000-100000000000`.replace(/[018]/g, (char) => {
    const digit = Number(char)

    return (
      digit ^
      (window.crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (digit / 4)))
    ).toString(16)
  })
/* eslint-enable no-bitwise */

const getCookieDomain = (): string | undefined => {
  const { hostname } = window.location

  if (!hostname.includes(`.`) || /^[\d.]+$/.test(hostname)) {
    return undefined
  }

  return `.${hostname.split(`.`).slice(-2).join(`.`)}`
}

let cachedDeviceId: string

export const getDeviceId = (): string => {
  if (typeof window === `undefined`) {
    return ``
  }

  if (cachedDeviceId) {
    return cachedDeviceId
  }

  cachedDeviceId = Cookies.get(DEVICE_ID_COOKIE) || generateDeviceId()

  Cookies.set(DEVICE_ID_COOKIE, cachedDeviceId, {
    domain: getCookieDomain(),
    path: `/`,
    sameSite: `Lax`,
    secure: window.location.protocol === `https:`,
    expires: DEVICE_ID_LIFETIME_DAYS,
  })

  return cachedDeviceId
}

export const logDeviceId = (): void => {
  // eslint-disable-next-line no-console
  console.log(`deviceId:`, getDeviceId())
}
